"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutWidgetRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
function DashboardLayoutWidgetRenderer(props) {
    var item = props.item, screen = props.screen, debug = props.debug, className = props.className, contentRef = props.contentRef, isResizedByLayoutSizingStrategy = props.isResizedByLayoutSizingStrategy, minHeight = props.minHeight, height = props.height, allowOverflow = props.allowOverflow, children = props.children;
    var _a = item.size()[screen], heightAsRatio = _a.heightAsRatio, gridHeight = _a.gridHeight;
    var style = react_1.useMemo(function () {
        var computedStyle = {
            minHeight: minHeight,
            height: height,
        };
        if (allowOverflow) {
            computedStyle.overflowX = "hidden";
            computedStyle.overflowY = "auto";
        }
        if (debug) {
            if (!heightAsRatio) {
                computedStyle.outline = "solid 1px yellow";
            }
            else {
                computedStyle.border = isResizedByLayoutSizingStrategy
                    ? "dashed 1px #d6d6d6"
                    : "solid 1px green";
            }
        }
        return computedStyle;
    }, [minHeight, height, allowOverflow, debug, heightAsRatio, isResizedByLayoutSizingStrategy]);
    return (react_1.default.createElement("div", { ref: contentRef, className: classnames_1.default("gd-fluidlayout-column-container", className, {
            "custom-height": !!gridHeight,
        }), style: style }, children));
}
exports.DashboardLayoutWidgetRenderer = DashboardLayoutWidgetRenderer;
//# sourceMappingURL=DashboardLayoutWidgetRenderer.js.map